import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { registerElements } from 'genesys-spark-components'
import { SimpleToastGroupComponent } from './simple-toast-group.component';

@NgModule({
  declarations: [
    SimpleToastGroupComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ],
  exports: [
    SimpleToastGroupComponent
  ]
})
export class SimpleToastGroupModule {
  constructor() {
    registerElements();
  }
}
